<template>
    <b-row class="user_bg_color">
        <b-col>
            <div class="ml-4 mr-4">
                <div class="title1 mb-2 pt-2">
                    <span class="fa fa-arrow-left mr-2" @click="$router.push('./')"></span>
                    Create User
                </div>
                <v-stepper alt-labels v-model="e1" class="user_bg_color">
                    <v-stepper-header>
                        <v-stepper-step step="1" class="v-stepper-step-outline stepper-step-margin">User
                            Information</v-stepper-step>
                        <v-divider />

                        <v-stepper-step step="2" class="v-stepper-step-outline">Address Info</v-stepper-step>
                        <v-divider />

                        <v-stepper-step step="3" class="v-stepper-step-outline">Access Control</v-stepper-step>
                        <v-divider />

                        <v-stepper-step step="4" class="v-stepper-step-outline">KYC verification</v-stepper-step>
                        <v-divider />

                        <v-stepper-step step="5" class="v-stepper-step-outline">Done</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <s-userinfo ref="userInfo" class="mt-2">
                                <template v-slot:footer-button="data">
                                    <div class="button-wrapper my-2">
                                        <b-button btn-color="primary" @isValid="
                                            (val) => (userInfoValid = val)
                                        " @click="userInfoToNext(data.data)">
                                            Next
                                        </b-button>
                                    </div>
                                </template>
                            </s-userinfo>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <s-addressinfo :tenants="tenants" @place_changed="setPlace" ref="addressInfo" class="mt-2">
                                <template v-slot:footer-button="data">
                                    <div class="button-wrapper my-2">
                                        <b-button flat @click="e1 = 1" btn-color="primary" class="mr-3">
                                            <span class="fa fa-reply"></span>
                                        </b-button>
                                        <b-button btn-color="primary" @click="AddressToNext(data.data)">
                                            Next
                                        </b-button>
                                    </div>
                                </template>
                            </s-addressinfo>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <s-acess class="mt-2" ref="userAccess">
                                <template v-slot:footer-button="data">
                                    <div class="button-wrapper my-2">
                                        <b-button flat @click="e1 = 2" btn-color="primary" class="mr-3">
                                            <span class="fa fa-reply"></span>
                                        </b-button>
                                        <b-button btn-color="primary" @click="AccessToNext(data.data)">
                                            Next
                                        </b-button>
                                    </div>
                                </template>
                            </s-acess>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                            <s-kyc class="mt-2" ref="kycForm" @readKYC="KYCUpdate($event)" :documentList="documentList"
                                :userID="currentUser">
                                <template v-slot:footer-button="data">
                                    <div class="button-wrapper my-2">
                                        <b-button flat @click="e1 = 3" btn-color="primary" class="mr-3">
                                            <span class="fa fa-reply"></span>
                                        </b-button>
                                        <b-button btn-color="primary" @click="AgreeToNext(data.data)">
                                            Next
                                        </b-button>
                                    </div>
                                </template>
                            </s-kyc>
                        </v-stepper-content>

                        <v-stepper-content step="5">
                            <s-thanks @done="done"></s-thanks>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import AddressStepper from "@/components/User/AddressStepper.vue";
import sUserInfo from "@/components/User/UserInfoStepper.vue";
import AcessStepper from "@/components/User/AccessStepper.vue";
import sThanks from "@/components/User/ThankYouStepper.vue";
import sAgreement from "@/components/Tenant/Agreement.vue";
import sKYC from "@/components/User/KYC_v2.vue";

export default {
    name: "CreateUser",
    components: {
        "s-addressinfo": AddressStepper,
        "s-userinfo": sUserInfo,
        "s-acess": AcessStepper,
        sThanks,
        sAgreement,
        "s-kyc": sKYC,
        cInput,
    },
    data() {
        return {
            currentUser: null,
            e1: 0,
            tenants: [],
            kycChangeObj: {},
            userinfo: null,
            address: null,
            authentication: null,
            agreement: null,
            documentList: null,
            extendedAttributes: null,
            userInfoValid: false,
            position: {
                lat: 0,
                lng: 0,
            },
        };
    },
    methods: {
        async userInfoToNext(item) {
            const isValid = await this.$refs.userInfo.isValid();
            if (!isValid) return;
            this.userinfo = item.userinfo;
            this.extendedAttributes = item.extendedAttributes;
            this.e1 = 2;
        },
        async AddressToNext(item) {
            const isValid = await this.$refs.addressInfo.isValid();

            if (!isValid) return;
            this.address = item.address;
            this.e1 = 3;
        },
        async AccessToNext(item) {
            console.log(item, "item");
            const isValid = await this.$refs.userAccess.isValid();
            if (!isValid) return;

            this.authentication = item;
            // this.e1 = 4;
            const { address, userinfo, authentication, extendedAttributes } =
                this;
            let orgaccess = [];
            if (
                authentication.orgAccessList &&
                authentication.orgAccessList.length > 0
            ) {
                authentication.orgAccessList.map((obj) => {
                    orgaccess.push(obj._id);
                });
            }
            let rolesarray = [];
            authentication.role.map((obj) => {
                rolesarray.push(obj._id);
            });
            let payload = {
                extendedAttributes: extendedAttributes,
                name: {
                    first: userinfo.first,
                    last: userinfo.last,
                },
                experience: {
                    value: userinfo.value,
                    uom: userinfo.uom,
                },
                profilePhoto: userinfo.profilePhoto,
                dob: userinfo.dob,
                gender: userinfo.gender,
                aboutMe: userinfo.aboutMe,
                maritalStatus: userinfo.maritalStatus,
                education: userinfo.education,
                authentication: {
                    email: userinfo.email,
                    userName: authentication.userName,
                    password: authentication.password,
                    phone: userinfo.phone,
                },
                address,
                authorization: {
                    geoAccess: {},
                    orgAccess: {
                        orgAccessLevel: authentication.orgAccessLevel
                            ? authentication.orgAccessLevel.value
                            : "Global",
                        orgAccessList: orgaccess,
                    },
                    roles: rolesarray,
                },
                category: authentication.category.value,
                tenant: this.userTenantId,
                //  officeHierarchy:this.$currentUserData._id,
            };
            /*  if (this.userRole === "Tenant") {
        payload.officeHierarchy = {
          category: "TENANT",
          _id: this.userId
        };
      }*/
            if (this.userRole === "Partner") {
                payload.officeHierarchy = this.userId;
            }
            await this.$store
                .dispatch("tenant/createTenantSubAdmin", payload)
                .then((result) => {
                    this.$swal({
                        title: "Success",
                        text: "User details are submitted successfully.Please Go ahead for KYC Verification.",
                        type: "success",
                    });
                    this.e1 = 4;
                    this.currentUser = result.response._id;
                });
        },
        async AgreeToNext(item) {
            const isValid = await this.$refs.kycForm.isValid();
            if (!isValid) return;

            if (
                !(
                    item.addressProofFront &&
                    item.addressProofBack &&
                    item.photoIdFront &&
                    item.photoIdBack
                )
            ) {
                this.$refs.kycForm.filesSubmited = false;
                return;
            }
            this.$refs.kycForm.filesSubmited = true;
            const success = await this.$refs.kycForm.submitKyc(
                this.currentUser,
            );
            if (success) this.e1 = 5;
        },
        done() {
            this.$router.push({ path: "/user" });
        },
        async setPlace(data) {
            let place = await data;
            let position = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            this.position = position;
        },
        async getKYCList() {
            this.currentTenant = "5ec257652872e3197f808af8";
            this.$store
                .dispatch("tenant/fetchKYCListByTenant", this.currentTenant)
                .then((result) => {
                    this.documentList = result.response;
                });
        },
        KYCUpdate(event) {
            this.kycChangeObj = event;
        },
    },
    computed: {
        userRole() {
            if (this.$store.getters["auth/getUserRole"]) {
                return this.$store.getters["auth/getUserRole"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
            }
        },
        userId() {
            if (this.$store.getters["auth/getUserID"]) {
                return this.$store.getters["auth/getUserID"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
            }
        },
        userTenantId() {
            if (this.userRole === "Tenant") {
                return this.userId;
            } else if (this.userRole === "Partner") {
                return JSON.parse(sessionStorage.getItem("userLogin"))[
                    "tenant"
                ];
            } else {
                return null;
            }
        },
    },
};
</script>

<style scoped>
.card {
    border-width: inherit;
    border-radius: 2px;
    box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

[col-4="image"] {
    background-color: aliceblue !important;
}

[btn-back="primary"] {
    background-color: var(--primary) !important;
    margin: 0px;
    height: 32px;
    color: white;
}

.img-avatar {
    margin-top: 150px !important;
}
</style>
<style>
.v-stepper {
    box-shadow: none;
}

.v-stepper__header {
    box-shadow: none;
}

.v-stepper__label {
    text-align: center;
}

.v-btn:before {
    opacity: -0.12 !important;
}

.v-stepper--alt-labels .v-stepper__step {
    flex-basis: 0px;
}

.v-stepper-step-outline {
    border: 1px solid var(--primary) !important;
    height: 0px;
    border-radius: 50%;
    width: 0px;
    margin-top: 8px;
    /* margin-right: 0px; */
    /* margin-left: 0; */
    margin-bottom: 40px;
    float: left;
}

@-moz-document url-prefix() {
    .v-stepper-step-outline {
        padding: 24px 4px 24px 4px;
    }
}

/* Active Tab Class*/
.theme--light.v-stepper .v-stepper__step__step,
.theme--light.v-stepper .v-stepper__step__step .v-icon {
    color: #ffffff;
    background-color: var(--primary) !important;
}

.v-stepper--alt-labels .v-stepper__step__step {
    margin-right: 0;
    margin-bottom: 22px;
    margin-top: -21px;
}

.v-stepper__step__step {
    min-height: 42px;
    min-width: 42px !important;
}

.v-stepper__content {
    padding: 0px !important;
    margin-top: 25px;
}

/* Deactive Stepper */
.theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
    background: var(--primary) !important;
}

/* divider between stepper */
.v-stepper--alt-labels .v-stepper__header .v-divider {
    margin: 35px 0px;
    -ms-flex-item-align: start;
    align-self: flex-start;
    border-top: 1px dashed black;
    letter-spacing: 8px;
}

.v-stepper__header {
    height: auto;
    width: 100%;
    max-width: 876px;
    margin: 0 auto;
}

.title1 {
    font-weight: 700;
    font-size: 21px;
    margin-bottom: 5px;
}

.user_bg_color {
    background: #f2f5f9 !important;
    margin-top: 15px;
}

@media only screen and (max-width: 959px) {
    .v-stepper:not(.v-stepper--vertical) .v-stepper__step__step {
        margin-top: -21px;
    }
    .v-stepper__header {
        height: auto;
        width: 100% !important;
        margin-left: 0 !important;
    }
}

/* --- Mobile stepper responsiveness --- */
@media (max-width: 767.98px) {
    .v-stepper__header {
        width: 100% !important;
        margin-left: 0 !important;
        padding: 0 12px;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        flex-wrap: nowrap;
    }

    /* Prevent step labels from wrapping into tall blocks; allow horizontal scroll */
    .v-stepper--alt-labels .v-stepper__step {
        flex: 0 0 auto;
    }

    /* Dividers consume a lot of space on mobile; hide them */
    .v-stepper--alt-labels .v-stepper__header .v-divider {
        display: none;
    }

    /* Reduce visual spacing so header doesn't push content down too much */
    .v-stepper-step-outline {
        margin-left: 0 !important;
        margin-bottom: 12px;
    }

    .v-stepper--alt-labels .v-stepper__step__step {
        margin-top: 0;
        margin-bottom: 10px;
    }

    .v-stepper__content {
        margin-top: 12px;
    }
}

.stepper-step-margin {
    margin-left: 0;
}
</style>
